import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import TimePicker from "react-time-picker";
import {Alert, Spinner} from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as moment from "moment";

class DeviceGroupScheduleExceptionForm extends Component {

    state = {
        form: {
            id: null,
            date: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
            deviceGroupId: null,
            startTime: null,
            endTime: null,
            type: 'Include'
        },
        loading: false,
        errorResponse: null
    };

    componentDidMount() {
        const { data } = this.props;
        console.log(data);
        if(data) {
            this.setState({
                form: {
                    id: data.id,
                    date: data.date,
                    deviceGroupId: data.deviceGroupId,
                    startTime: data.startTime,
                    endTime: data.endTime,
                    type: data.type,
                },
                loading: true
            });
        } else {
            this.setState({
                loading: true
            });
        }
    }

    handleOnChangeTime = (value, name) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [name]: value
            }
        });
    };

    handleOnChangeSelect = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleOnChangeDate = (value, name) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss")
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const {submit} = this.props;
        submit(this.state.form, (error) => {
            this.setState({
                ...this.state,
                errorResponse: error
            })
        });
    };

    render() {
        const { t } = this.props;
        const { errorResponse } = this.state;

        const errorKeys = errorResponse ? Object.keys(errorResponse.data.errorMessages) : null;

        return (
            <React.Fragment>
                {this.state.loading ? (
                    <form className="needs-validation" onSubmit={ this.handleSubmit }>

                        { !errorResponse || (
                            <Alert variant={"danger"}>
                                <ul>
                                    { errorKeys.map((value, idx) => {
                                        return (<li key={idx}><b>{ t(`valid.${value}`) }:</b> { t(`msg.${errorResponse.data.errorMessages[value][0]}`) } </li>)
                                    }) }
                                </ul>
                            </Alert>
                        ) }

                        <div className="form-group ">
                            <label htmlFor="date" className="col-form-label"> {t('date')} </label>
                            <div>
                                <DatePicker
                                    locale={localStorage.getItem('i18nextLng')}
                                    className="form-control"
                                    selected={new Date(this.state.form.date)}
                                    onChange={(e) => this.handleOnChangeDate(e, 'date')}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="startTime" className="col-form-label" > {t('start-time')} </label>
                            <TimePicker
                                className='form-control'
                                onChange={(e) => this.handleOnChangeTime(e, 'startTime')}
                                maxDetail='minute'
                                value={this.state.form.startTime}
                                locale="pl-PL"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="endTime" className="col-form-label" > {t('end-time')} </label>
                            <TimePicker
                                className='form-control'
                                onChange={(e) => this.handleOnChangeTime(e, 'endTime')}
                                maxDetail='minute'
                                value={this.state.form.endTime}
                                locale="pl-PL"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="col-form-label"> {t('type')} </label>
                            <select className="form-control" defaultValue={this.state.form.type } onChange={this.handleOnChangeSelect} name="type">
                                <option value="Include" >{t('include')}</option>
                                <option value="Exclude" >{t('exclude')}</option>
                            </select>
                        </div>

                        <div className="form-group float-right">
                            <button type="submit" className="btn btn-primary">
                                <i className="fas fa-edit"> </i> { this.state.form.id ? (t('save-changes')) : (t('create')) }
                            </button>
                        </div>
                    </form>
                ) : (
                    <React.Fragment>
                        <Spinner animation={"border"} />
                        <p>Loading ...</p>
                    </React.Fragment>
                )}

            </React.Fragment>
        );
    }

}
export default withNamespaces()(DeviceGroupScheduleExceptionForm)
